import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { get, set } from '@ember/object';

export default Route.extend({
  abilities: service(),
  coachingService: service(),
  navbarSettings: service(),
  store: service(),

  model(params) {
    let coachingService = this.coachingService;
    set(coachingService, 'selectedIndividualId', params.individualId);
    return coachingService.refreshSelectedIndividualToken().then(() => {
      return this.abilities
        .loadCoachingAbilities({ individualId: params.individualId })
        .then(() => {
          return this.store
            .findRecord('coaching/individual', params.individualId)
            .then((record) => {
              set(this, 'navbarSettings.title', get(record, 'name'));
              return {
                record,
              };
            });
        });
    });
  },
});
